import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { fadeOutThen } from '../helpers';

class WorkFilters extends React.Component {
	constructor() {
		super();
		this.closeOpenFilters = this.closeOpenFilters.bind(this);
		this.filterMouseEnter = this.filterMouseEnter.bind(this);
		this.filterMouseLeave = this.filterMouseLeave.bind(this);
		this.handleSortLinks = this.handleSortLinks.bind(this);
		this.otherWorkTypeLinks = this.otherWorkTypeLinks.bind(this);
	}

	closeOpenFilters(action) {

		// Close the checkbox if we're sorting work
		let filterCheckbox = document.getElementById('filter-toggle');
		let filterIsChecked = filterCheckbox.checked;

		if(action === 'close' && filterIsChecked) {
			filterCheckbox.checked = false;
		} else if(action === 'open' && !filterIsChecked) {
			filterCheckbox.checked = true;
		}
	}

	filterMouseEnter() {
		if((this.props.activeCollection === 'modern' && this.props.columns > 1) || (this.props.activeCollection === 'history' && this.props.columns > 2)) {
			this.closeOpenFilters('open');
		}
	}

	filterMouseLeave() {
		if((this.props.activeCollection === 'modern' && this.props.columns > 1) || (this.props.activeCollection === 'history' && this.props.columns > 2)) {
			this.closeOpenFilters('close');
		}
	}

	// determines and labels active sort
	handleSortLinks() {
		const sortLinks = document.querySelectorAll('.sort li a');

		sortLinks.forEach((link) => {
			if(link.getAttribute('href') === this.props.pathname) {
				link.classList.add('active');
			} else {
				if(link.classList.contains('active')) {
					link.classList.remove('active');
				}
			}
		});
	}

	// lets us do a transition before resorting work to avoid masonry goofing things up
	handleSortLinkClicks(target, e) {
		e.preventDefault();
		this.closeOpenFilters('close');
		
		fadeOutThen(document.querySelector('.pageContent--workThumbnails'), function() {
			this.props.history.push(target);
		}.bind(this));
	}

	otherWorkTypeLinks(activeCollection, activeType) {
		let collectionOptions = [];
		let theLinks = [];
		let workDirectory = '';

		if(activeCollection === 'modern') {
			workDirectory = 'work';
			collectionOptions = [
				{
					link: 'logos',
					title: 'Logos'
				},
				{
				 	link: 'graphics',
				 	title: 'Graphics'
				},
				{
				 	link: 'art-in-architecture',
				 	title: 'Art in Architecture'
				}
			];
		} else {
			workDirectory = 'history';
			collectionOptions = [
				{
					link: 'all',
					title: 'All'
				},
				{
					link: 'logos',
					title: 'Logos'
				},
				{
					link: 'graphics',
					title: 'Graphics'
				},
				{
					link: 'exhibits',
					title: 'Exhibits'
				}
			];
		}

		collectionOptions.forEach((collection) => {

			if(collection.link === activeType && activeCollection === 'modern') {
				return;
			}

			theLinks.push(<span className={collection.link === activeType ? 'active' : ''} key={theLinks.length}><Link className={collection.link === activeType ? 'active' : ''} to={`/${workDirectory}/${collection.link}/`} onClick={()=>{this.closeOpenFilters('close')}}>{collection.title}</Link></span>);
		});

		return theLinks;
	}

	componentDidMount() {
		this.handleSortLinks();

		let filterLabel = document.querySelector('.pageContent--workFilterAndSort label');
		let filterOtherLinks = document.querySelector('.filter--otherLinks');

		filterLabel.addEventListener('mouseenter', e => this.filterMouseEnter(), true);
		filterLabel.addEventListener('mouseleave', e => this.filterMouseLeave(), true);

		filterOtherLinks.addEventListener('mouseenter', e => this.filterMouseEnter(), true);
		filterOtherLinks.addEventListener('mouseleave', e => this.filterMouseLeave(), true);
	}

	componentDidUpdate(prevProps, prevState) {
		// sortBy change from an URL change

		if(prevProps.sortBy !== this.props.sortBy) {
			this.handleSortLinks();
		}
	}

	render() {

		if(this.props.activeType !== undefined && this.props.activeType) {
			var filterName = this.props.activeType.replace(/-/g, ' ');
		} else {
			filterName = 'undefined';
		}

		let workDirectory = this.props.activeCollection === 'modern' ? 'work' : 'history';

		return (
			<section className="pageContent--workFilterAndSort">
				<input type="checkbox" id="filter-toggle" />
				<label htmlFor="filter-toggle">{filterName}</label>
			<div className="filter--otherLinks">
				{this.otherWorkTypeLinks(this.props.activeCollection, this.props.activeType)}
			</div>
			{	this.props.activeCollection === 'modern' &&
				<ul className="sort">
					<li>
					 {this.props.enabled ? 
								<a href={`/${workDirectory}/${this.props.activeType}/`} onClick={(e)=>{this.handleSortLinkClicks(e.target.getAttribute('href'), e)}}>Curated</a>
					 		: <span>Curated</span>
					 	}
					</li>
					<li>
						{this.props.enabled ? 
								<a href={`/${workDirectory}/${this.props.activeType}/az/`} onClick={(e)=>{this.handleSortLinkClicks(e.target.getAttribute('href'), e)}}>A–Z</a>
							: <span>A–Z</span>
						}
					</li>
					<li>
						{this.props.enabled ? 
								<a href={`/${workDirectory}/${this.props.activeType}/new/`} onClick={(e)=>{this.handleSortLinkClicks(e.target.getAttribute('href'), e)}}>Newest</a>
							: <span>Newest</span>
						}
					</li>
				</ul>
			}
			</section>
		)
	}
}

export default withRouter(WorkFilters);


/** WEBPACK FOOTER **
 ** ./src/components/WorkFilters.js
 **/